import React from 'react'
import { MapPin, MapPinOff } from 'lucide-react'

interface POIToggleControlProps {
  showPOIs: boolean
  onToggle: () => void
  className?: string
}

export function POIToggleControl({ showPOIs, onToggle, className = '' }: POIToggleControlProps) {
  const isEmbed = className.includes('embed-control')
  
  return (
    <button
      onClick={onToggle}
      className={isEmbed ? className : `flex items-center justify-center p-2 text-white hover:bg-gray-700/50 transition-colors ${className}`}
      title={showPOIs ? 'Hide POIs' : 'Show POIs'}
      style={isEmbed ? { display: 'flex', alignItems: 'center', justifyContent: 'center' } : {}}
    >
      {showPOIs ? (
        <MapPin className={isEmbed ? 'w-[18px] h-[18px]' : 'w-4 h-4'} />
      ) : (
        <MapPinOff className={isEmbed ? 'w-[18px] h-[18px]' : 'w-4 h-4'} />
      )}
    </button>
  )
}